import Cookies from 'js-cookie';
import { getCookieDomain } from 'config/app.config';

export const get = (name: string): string => Cookies.get(name);

export const remove = (name: string): void => Cookies.remove(name, { domain: getCookieDomain() });
